import { Route, RouteConfig } from "vue-router";

const commonProfileRouteFields = (name: string): Partial<RouteConfig> => ({
  props: {
    default: (route: Route) => ({
      userId: route.params.userId,
      feedId: route.query.feedId,
      storyId: route.query.storyId,
    }),
    createPost: true,
  },
  components: {
    default: () => import(/* webpackChunkName: "profile" */ "@/views/PageProfile"),
    unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
    stories: () => import(/* webpackChunkName: "profile" */ "@/views/Stories"),
  },
  children: [
    {
      name: `${name}/live`,
      path: "live",
      props: route => ({ userId: route.params.userId }),
      component: () =>
        import(
          /* webpackChunkName: "profile" */ "@/views/PageProfile/components/StreamControllers/SingleLiveController"
        ),
    },
    {
      name: `${name}/collab-live`,
      path: "collab-live/:chatId",
      props: route => ({ userId: route.params.userId, chatId: route.params.chatId }),
      component: () =>
        import(
          /* webpackChunkName: "profile" */ "@/views/PageProfile/components/StreamControllers/CollabLiveController"
        ),
    },
  ],
});

export const profileRoutes: RouteConfig[] = [
  {
    path: "/:username",
    name: "profile",
    ...commonProfileRouteFields("profile"),
    meta: {
      toBottom: true,
    },
  },
  {
    path: "/profile/:userId",
    name: "profileById",
    ...commonProfileRouteFields("profileById"),
  },
  {
    path: "/profile/:userId/followers",
    name: "followersById",
    component: () => import("@/views/PageFollowers"),
    props: (route: Route) => ({
      userId: route.params.userId,
      isFollowingPage: false,
    }),
  },
  {
    path: "/profile/:userId/following",
    name: "followingById",
    component: () => import("@/views/PageFollowers"),
    props: (route: Route) => ({
      userId: route.params.userId,
      isFollowingPage: true,
    }),
  },
];
